<div class="container">
  <div class="content-div"  #contentDiv>
    <!-- Loading state -->
    <div *ngIf="loading" class="loading-container">
    <div class="loader-wrapper" [@fadeOut] aria-hidden="true">
      <img src="/assets/animate/beaker-loader-dark.gif" alt="" />
      <p class="loading-text">Loading career details...</p>
    </div>
    </div>

    <!-- Error state -->
    <div *ngIf="error" class="error-container">
      <div class="error-message">
        <p>{{ error }}</p>
        <button class="retry-button" (click)="redirectToExploreCareers()">Back to Career Matches</button>
      </div>
    </div>

    <div *ngIf="!loading && !error">
      <app-summary-header 
        [title]="title"
        [alternativeNames]="alternativeNames">
      </app-summary-header>

    <div class="main-content">
      <div class="content-layout">
        <div class="sidebar">
          <app-career-goal [onetCode]="onetCode" [title]="careerDetails?.title || ''"></app-career-goal>
          <app-match-score [matchScore]="careerData?.match_score || 'h1_plus'"></app-match-score>
        </div>

        <div class="main-content-area">
          <app-salary-growth
            [areaMedianSalary]="areaMedianSalary"
            [areaGrowthProjection]="areaGrowthProjection"
            location="CA">
          </app-salary-growth>

          <div class="section-divider"></div>

          <!-- Job Summary and Tasks -->
          <div class="description-row">
            <div class="description-section">
              <h2>Job Summary</h2>
              <p>{{ jobSummary }}</p>
            </div>
            <div class="description-section">
              <h2>Typical Tasks</h2>
              <ul *ngIf="typicalTasks.length > 0; else noTasks">
                <li *ngFor="let task of typicalTasks">{{ task }}</li>
              </ul>
              <ng-template #noTasks>
                <p>Typical tasks information not available.</p>
              </ng-template>
            </div>
          </div>

          <div class="section-divider"></div>

          <!-- Education, Skills, Interest -->
          <div class="info-row">
            <div class="info-section education-section">
              <h2>Education</h2>
              <div class="education-level">
                <div class="education-icons">
                  <img *ngFor="let icon of getEducationIcons(); let i = index" 
                       [src]="icon ? 'assets/icons/summary/graduation-cap-filled.svg' : 'assets/icons/summary/graduation-cap.svg'" 
                       alt="Education level indicator"
                       class="education-icon">
                </div>
                <p>{{ getEducationDescription() }}</p>
              </div>
            </div>
            <div class="info-section skills-section">
              <h2>Top Skills</h2>
              <div class="skills-tags" *ngIf="topSkills.length > 0; else noSkills">
                <span *ngFor="let skill of topSkills" class="skill-tag">{{ skill }}</span>
              </div>
              <ng-template #noSkills>
                <p class="no-skill-info-text">Skills information not available.</p>
              </ng-template>
            </div>
            <div class="info-section interest-section">
              <h2>Interest Type</h2>
              <button class="view-profile" (click)="viewProfile()">
                <span>View your profile ></span>
              </button>
              <div class="interest-type">
                <div class="interest-icon">{{ interestTypes.split(' - ')[0] || 'N/A' }}</div>
                <span>{{ interestTypes.split(' - ')[1] || interestTypes }}</span>
              </div>
            </div>
          </div>

          <div class="section-divider"></div>

          <!-- Work Setting -->
          <div class="work-setting-section">
            <h2>Work Setting</h2>
            <div class="work-setting-grid">
              <div class="work-setting-card">
                <h4>40+ Hours/Week</h4>
                <div *ngIf="workSetting.hoursWeek.check !== undefined; else noHoursData" class="binary-indicator" [class.positive]="workSetting.hoursWeek.check" [class.negative]="!workSetting.hoursWeek.check">
                  <img [src]="workSetting.hoursWeek.check ? 'assets/icons/summary/badge-check.svg' : 'assets/icons/summary/badge.svg'"
                       alt="Hours per week indicator"
                       class="badge-icon">
                </div>
                <ng-template #noHoursData>
                  <div class="no-data">
                    <span class="no-data-label">no data</span>
                  </div>
                </ng-template>
              </div>
              <div class="work-setting-card">
                <h4>Daily or Weekly Deadlines</h4>
                <div class="scale-indicator" [class]="getScaleLabel(workSetting.timePressure).toLowerCase()">
                  <div class="scale-bars">
                    <div *ngFor="let bar of getScaleBars(workSetting.timePressure)" class="bar" [class.active]="bar"></div>
                  </div>
                  <span class="scale-label">{{ getScaleLabel(workSetting.timePressure) }}</span>
                </div>
              </div>
              <div class="work-setting-card">
                <h4>Contact with Others</h4>
                <div class="scale-indicator" [class]="getScaleLabel(workSetting.contactWithOthers).toLowerCase()">
                  <div class="scale-bars">
                    <div *ngFor="let bar of getScaleBars(workSetting.contactWithOthers)" class="bar" [class.active]="bar"></div>
                  </div>
                  <span class="scale-label">{{ getScaleLabel(workSetting.contactWithOthers) }}</span>
                </div>
              </div>
              <div class="work-setting-card">
                <h4>Daily or Weekly Public Speaking</h4>
                <div class="scale-indicator" [class]="getScaleLabel(workSetting.publicSpeaking).toLowerCase()">
                  <div class="scale-bars">
                    <div *ngFor="let bar of getScaleBars(workSetting.publicSpeaking)" class="bar" [class.active]="bar"></div>
                  </div>
                  <span class="scale-label">{{ getScaleLabel(workSetting.publicSpeaking) }}</span>
                </div>
              </div>
              <div class="work-setting-card">
                <h4>Decision-Making Freedom</h4>
                <div class="scale-indicator" [class]="getScaleLabel(workSetting.freedomToMakeDecisions).toLowerCase()">
                  <div class="scale-bars">
                    <div *ngFor="let bar of getScaleBars(workSetting.freedomToMakeDecisions)" class="bar" [class.active]="bar"></div>
                  </div>
                  <span class="scale-label">{{ getScaleLabel(workSetting.freedomToMakeDecisions) }}</span>
                </div>
              </div>
              <div class="work-setting-card">
                <h4>Teamwork Importance</h4>
                <div *ngIf="workSetting.teamWork > 0; else noTeamworkData" class="scale-indicator" [class]="getScaleLabel(workSetting.teamWork).toLowerCase()">
                  <div class="scale-bars">
                    <div *ngFor="let bar of getScaleBars(workSetting.teamWork)" class="bar" [class.active]="bar"></div>
                  </div>
                  <span class="scale-label">{{ getScaleLabel(workSetting.teamWork) }}</span>
                </div>
                <ng-template #noTeamworkData>
                  <div class="no-data">
                    <span class="no-data-label">no data</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="section-divider"></div>

          <!-- Related Careers -->
           <!-- Hiding related careers section for now until all data is available -->
          <!-- <div class="related-careers-section">
            <app-related-careers [relatedCareers]="relatedCareers"></app-related-careers>
          </div> -->

          <div class="data-attribution">
            <p>Data from <a href="https://www.onetonline.org/" target="_blank" (click)="onOnetLinkClick()">O*Net</a>, <a href="https://projectionscentral.org/" target="_blank" (click)="onPmpLinkClick()">PMP</a></p>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>